module.exports = __webpack_public_path__ + "media/customizations/svlaliving/logo-c5436a45ec29747ac14ddf9697a24d20.png";